import Rellax from 'rellax';
import { debounce, map, trim } from 'lodash';

const parallax = () => {
  /* global document, window */
  // Parallax double feature images
  window.parallaxImages = [];
  // Parallax full images use the Rellax library to do their thing.
  const parallaxImages = document.querySelectorAll('.is-parallax.paragraph--type-double-image-feature, .is-parallax.paragraph--type-homepage-banner');
  map(parallaxImages, (component) => {
    const hasGroupLeft = !!trim(component.querySelector('.group-left').innerHTML);
    const hasGroupRight = !!trim(component.querySelector('.group-right').innerHTML);
    const image = component.querySelector('.field--name-display-field-copyparagraph-image-parallax img');
    image.style.transform3d = '';
    /* eslint-disable no-new */
    window.parallaxImages.push(new Rellax(image, {
      center: false,
      horizontal: false,
      relativeToWrapper: true,
      round: true,
      speed: !hasGroupRight && !hasGroupLeft ? -2.3 : -3.3,
      vertical: true,
      wrapper: component,
    }));
  });
  // When the window is resized, refresh all of the parallax components.
  const refreshParallaxComponents = () => {
    map(window.fullImages, item => item.refresh());
  };
  window.addEventListener('resize', debounce(refreshParallaxComponents, 200));
};

export default parallax;
